<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      partners: null,
    };
  },
  methods: {
    getPartners() {
      api
        .get('inventory/partners')
        .then((response) => {
          if (response.data.status == 'success') {
            this.partners = response.data.list
          }
        })
    }
  },
  mounted() {
    this.getPartners()
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/inventory">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/inventory">Reposição</router-link></li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Parceiros</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!partners" class="text-center">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>

    <div v-else-if="partners && partners.length == 0">
      <div class="card">
        <div class="card-body text-center">
          Nenhum informativo encontrado.
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-md-6 col-xl-4" v-for="(row, id) in partners" :key="id">
          <router-link class="text-dark" tag="a" :to="'/inventory/partners/' + row.id">
            <div class="card card-partner">
              <div class="card-body p-2 d-flex align-items-center">
                <div class="logo">
                  <img :src="row.image.logo">
                </div>
                <div>
                  <h5 class="mb-0">{{ row.name }}</h5>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.card-partner .d-flex {
  gap: 10px;
}
.card-partner .logo img {
  border-radius: 50%;
  width: 100px;
}
</style>
